{
  "title": "Home",
  "findYourSpace": "FIND YOUR SPACE",
  "live": "Live",
  "loadingSpace": "Loading your space",
  "topBar": {
    "visibilityA11y": "Visible to people nearby",
    "visible": "Visible",
    "hidden": "Hidden",
    "visibleHint": "People can cue you",
    "hiddenHint": "People cannot see you",
    "peopleCount_one": "{{display}} person",
    "peopleCount_other": "{{display}} people"
  },
  "nearbyRange": {
    "closeBy": "Close by · {{distance}}",
    "nearby": "Nearby · {{distance}}",
    "localArea": "Local area · {{distance}}",
    "updateFailedTitle": "Unable to update nearby range",
    "within": "Within {{distance}}"
  },
  "cue": {
    "sendFailedTitle": "Unable to send Cue"
  },
  "share": {
    "title": "Join me on Opncue",
    "messageIntro": "Join me on Opncue. A place to meet people nearby who are open to connecting, and see when your connections are open to talk.",
    "failedTitle": "Unable to share",
    "failedBody": "We couldn’t open your sharing options. Please try again.",
    "cardTitle": "Not enough people here?",
    "cardBody": "Share Opncue with friends or on your social platforms. The more people who join, the fewer people have to feel alone.",
    "button": "Share Opncue"
  },
  "visibilityPrompt": {
    "cancelA11y": "Cancel becoming visible",
    "title": "Become visible first",
    "cueBody": "Turn visibility on so people can see and Cue you before sending a Cue to {{name}}.",
    "groupBody": "Turn visibility on to join or create Small Groups with people at this venue.",
    "visible": "Visible",
    "cueVisibleHint": "People nearby can see you and send Cues.",
    "groupVisibleHint": "People nearby can see you and join groups with you.",
    "confirm": "OK"
  },
  "venue": {
    "currentSpace": "CURRENT SPACE",
    "edit": "Join a space",
    "refreshTitle": "Location needs a refresh",
    "refreshBody": "Try detecting your location again. You can join a named space once we know roughly where you are.",
    "backendUnavailableTitle": "Opncue is having trouble connecting",
    "backendUnavailableBody": "Your location is available, but we can’t reach Opncue right now. Try again in a moment.",
    "offlineTitle": "You’re offline",
    "offlineBody": "Connect to the internet to find people and spaces nearby.",
    "locationFailedTitle": "Location access needed to find people nearby",
    "locationFailedBody": "Make sure location is turned on and Opncue has permission to use it, then try again.",
    "preciseTitle": "We couldn’t find your location",
    "preciseBody": "Approximate location can place you in a broad part of your city. Precise location helps Opncue show you people and groups closer to where you actually are.",
    "preciseAction": "Allow precise location",
    "preciseActionA11y": "Allow precise location access",
    "peoplePreciseTitle": "Precise location is needed to see who’s nearby",
    "peoplePreciseBody": "Approximate location can be off by more than a kilometre, so we can’t tell who is actually close to you. The rest of Opncue works without it.",
    "requestFailedTitle": "Opncue is having trouble connecting",
    "requestFailedBody": "We couldn’t refresh people and spaces nearby. Try again in a moment.",
    "retryConnectionA11y": "Try connecting again",
    "retryConnection": "Try again",
    "retryA11y": "Try finding your location again",
    "continueAnyway": "Continue",
    "continueAnywayA11y": "Continue without precise location",
    "retry": "Try again",
    "nearSpace": "Near {{name}}",
    "unnamedSpace": "A space nearby"
  },
  "panels": {
    "people": "People",
    "smallGroups": "Small Groups"
  },
  "filters": {
    "filter": "Filter",
    "filterCount_one": "{{count}} filter",
    "filterCount_other": "{{count}} filters",
    "clear": "Clear",
    "clearFilters": "Clear filters",
    "peopleA11y": "Filter people",
    "clearPeopleA11y": "Clear people filters",
    "closePeopleA11y": "Close people filters",
    "peopleTitle": "Filter people",
    "peopleBody": "Adjust your reach and narrow the people shown nearby.",
    "nearbyRange": "Nearby range",
    "ageRange": "Age range",
    "languages": "Languages",
    "friendshipGoal": "Friendship goal",
    "closeGroupsA11y": "Close Small Group filters",
    "groupsTitle": "Filter Small Groups",
    "groupsBody": "Narrow the Small Groups shown at this venue.",
    "goal": "Goal",
    "groupSize": "Group size",
    "anyAge": "Any age",
    "any": "Any",
    "peopleOption_one": "{{count}} person",
    "peopleOption_other": "{{count}} people",
    "profileAgeRequired": "Add your age band to use this filter.",
    "profileLanguagesRequired": "Add your languages to use this filter.",
    "profileGoalRequired": "Add your friendship goal to use this filter.",
    "whoToShow": "Who to show",
    "modeRadius": "Nearby",
    "modeSameSpace": "Same Space",
    "modeRadiusHint": "Everyone visible within your range.",
    "modeSameSpaceHint": "Only people who joined {{space}} too.",
    "sameSpaceJoin": "Change space",
    "sameSpaceJoined": "Change space, currently {{space}}",
    "sameSpaceFailedTitle": "Could not join that space",
    "sameSpaceLeaveFailedTitle": "Could not leave that space"
  },
  "groupGoals": {
    "casualHello": "Casual Hello",
    "coffeeChat": "Coffee Chat",
    "workStudyBreak": "Work/Study Break",
    "groupHangout": "Group Hangout",
    "trySomethingNew": "Try Something New",
    "exploreNearby": "Explore Nearby",
    "foodCoffee": "Food & Coffee",
    "walkFitness": "Walk/Fitness",
    "localEvent": "Local Event",
    "lowPressureChat": "Low-Pressure Chat",
    "other": "Other"
  },
  "groups": {
    "nameRequiredTitle": "Name your group",
    "nameRequiredBody": "Add a short name before creating it.",
    "createFailedTitle": "Unable to create Small Group",
    "locationRequiredBody": "Share your location so people close by can find and join this group.",
    "joinFailedTitle": "Unable to join Small Group",
    "intro": "Join or create a temporary group with people nearby.",
    "createGroup": "Create group",
    "small": "Small",
    "noMatchesTitle": "No matching Small Groups",
    "noMatchesBody": "Try clearing a filter or checking again when more groups start nearby.",
    "noneTitle": "No Small Groups nearby yet",
    "noneBody": "Start one for people nearby who are up for a quick hello, coffee, an activity",
    "nearbyCount_one": "{{count}} Small Group nearby",
    "nearbyCount_other": "{{count}} Small Groups nearby",
    "cardMeta": "{{memberCount}} / {{maxMembers}} people · {{timeLeft}} left",
    "open": "Open",
    "full": "Full",
    "view": "View",
    "joinAction": "Join",
    "openA11y": "Open {{name}}",
    "viewA11y": "View {{name}}",
    "joinA11y": "Join {{name}}",
    "cancelCreateA11y": "Cancel creating Small Group",
    "createTitle": "Create a Small Group",
    "createBody": "Keep it tiny, temporary, and tied to this venue.",
    "name": "Group name",
    "namePlaceholder": "Front table coffee",
    "selectGoal": "Select a goal",
    "customGoalPlaceholder": "Type your goal",
    "customGoalRequiredTitle": "Add your goal",
    "customGoalRequiredBody": "Type a short goal before creating this group.",
    "selectSize": "Select a group size",
    "durationQuestion": "How long should it last?",
    "selectDuration": "Select a duration",
    "minutes": "{{count}} min",
    "hours_one": "{{count}} hour",
    "hours_other": "{{count}} hours",
    "optionalNote": "Optional note",
    "notePlaceholder": "Anyone want to sit together for a bit?",
    "create": "Create",
    "cancelJoinA11y": "Cancel joining Small Group",
    "joinTitle": "Join this Small Group?",
    "joinSummary": "{{name}} · {{count}} people here · {{timeLeft}} left",
    "leaveAnytime": "You can leave anytime.",
    "join": "Join group",
    "rangeQuestion": "How close must people be to join?",
    "rangeHint": "Only people within {{distance}} can see this group or join it.",
    "joinOnly": "Join only",
    "joinAndCue": "Join & let members Cue me",
    "joinCueHint": "Choosing “Cue me” lets the people here ask to start a private conversation. You can change it in the group."
  },
  "people": {
    "emptyTitle": "Bring someone with you",
    "emptyBody": "Invite a friend or share Opncue with your community. Every new person creates more chances for people nearby to connect.",
    "waiting": "Waiting for visible people nearby",
    "noMatchesTitle": "No matching people",
    "noMatchesBody": "Try clearing one filter or checking again when more people become visible.",
    "openProfileA11y": "Open {{name}}’s public profile",
    "hereFor": "Here for: {{goal}}",
    "cueSentA11y": "Cue already sent",
    "sendCueA11y": "Send Cue to {{name}}",
    "sent": "Sent",
    "cue": "Cue",
    "waitingHere": "Waiting for visible people here"
  },
  "visibility": {
    "failedTitle": "Can't make you visible"
  }
}
